export interface IDataResponse<T = any> {
  Success?: boolean;
  Message?: string | null;
  Data?: T;
  success?: boolean;
  message?: string | null;
  data?: T;
  result:
    | any
    | {
        items: T[];
        pageNumber: number;
        pageSize: number;
        totalCount: number;
        totalPages: number;
      };
  statusCode?: number;
  errorMessages?: any[];
}

export interface IDataResponseCore<T> {
  success: boolean;
  message: string | any[] | null;
  data: T | any | null;
}

export interface IOption {
  label: string;
  value: string | number;
}

export interface LoginData {
  accessToken: string;
  refreshToken: string;
  userProfile: UserProfile;
}

export interface UserProfile {
  firstName: string;
  lastName: string;
  avatar?: any;
  roleCode: string;
  email: string;
  schoolName?: any;
  firstLogin: boolean;
  otp: string;
}

export interface ILoginResponse {
  status: string;
  data: LoginData;
  errors?: {
    code: number;
    field: string;
    message: string;
  }[];
}

export interface IRegisterResponse {
  status: string;
  data: LoginData;
  errors?: {
    code: number;
    field: string;
    message: string;
  }[];
}

export enum AUTH_TYPE {
  LOGIN,
  REGISTER,
  FORGOT_PASSWORD,
}

export enum PAGE_TYPE {
    QATICKET
}
export type MenuItem = {
  label: string;
  key: string;
  levels?: Levels[];
  children?: MenuItem[];
  url?: string;
  roleName?: string;
};
export type Levels = {
  label: string;
  class: MenuItem[];
};

export enum Status {
  SUCCESS = 'success',
}

export type Tabs = {
  tabName: string;
  url: string
}

// https://apihanhtrangso.nxbgd.vn/api/library/ListBookLinknNoPagination
// {
//   "keyword": "",
//   "documentTypeId": 0,
//   "pageIndex": 1,
//   "pageSize": 12,
//   "bookId": 600,
//   "pageStart": 6,
//   "pageStop": 7
// }

// https://apihanhtrangso.nxbgd.vn/api/practice/GetCountQuestionIndex?bookId=600&pageStart=6&pageStop=7

// https://apihanhtrangso.nxbgd.vn/api/Book/get-list-page-link?bookId=600&bookPageId=0&pageNo=7&keyword=

// https://apihanhtrangso.nxbgd.vn/api/Book/get-list-question?bookId=600&bookIndexId=0&pageIndex=6&numberOfPage=2

// https://apihanhtrangso.nxbgd.vn/api/lesson/get-list-by-book-pageno?bookid=600&pageStart=6&pageStop=7

// https://apihanhtrangso.nxbgd.vn/api/Question/list-question-location-by-bookid-and-pageno

// {
//   "bookId": 600,
//   "pageNo": 6
// }
